angular
  .module('pb.file')

  .service('S3Downloader', [
    '$q',
    '$http',
    '$filter',

    function($q, $http, $filter) {
      this.download = function(file) {
        const deferred = $q.defer();

        $http({ method: 'GET', url: '@@apiUrl' + '/settings' })
          .then(res => {
            const { data } = res || {};
            const { aws } = data || {};
            const { accessKeyId, bucket, encryption, region, secretAccessKey } =
              aws || {};

            const isAwsConfigValid = !!(
              accessKeyId &&
              secretAccessKey &&
              region &&
              bucket &&
              encryption
            );

            if (!isAwsConfigValid) {
              deferred.reject($filter('translate')('file.AWS_CONFIG_ERR'));
              return;
            }

            AWS.config.update({
              accessKeyId,
              secretAccessKey,
              region
            });

            const s3 = new AWS.S3();

            const params = {
              Bucket: bucket,
              Key: typeof file === 'object' ? file.key : file,
              Expires: 60
            };

            s3.getSignedUrl('getObject', params, (err, url) => {
              err ? deferred.reject(err) : deferred.resolve(url);
            });
          })
          .catch(err => {
            deferred.reject(err);
          });

        return deferred.promise;
      };
    }
  ]);
